import he from 'he';
import { useEffect, useState } from 'react';
import { useRecoilValue } from 'recoil';
import rehypeStringify from 'rehype-stringify';
import breaks from 'remark-breaks';
import remarkGfm from 'remark-gfm';
import remarkParse from 'remark-parse';
import remarkRehype from 'remark-rehype';
import { unified } from 'unified';
import { versionSelector } from '@/state/config';
export const useMarkdownToHtml = (markdownText) => {
    const [html, setHtml] = useState('');
    const [error, setError] = useState(null);
    const version = useRecoilValue(versionSelector);
    useEffect(() => {
        const convertMarkdownToHtml = async () => {
            try {
                // Backward compatibility for the old editor.
                // Check whether the markdown text includes any raw HTML links.
                if (/<a\s+(?:[^>]*?\s+)?href=(["'])(.*?)\1/.test(markdownText)) {
                    setHtml(markdownText);
                    return;
                }
                // Decode HTML entities in the input markdownText
                let decodedMarkdown = he.decode(markdownText);
                if (version === 'v2') {
                    // Preserve empty lines (\n\n) by adding non-breaking spaces
                    // This ensures that empty lines show up as visual spacing in the output
                    decodedMarkdown = decodedMarkdown.replace(/\n\n+/g, (match) => {
                        // For each empty line, add a line with just a non-breaking space
                        const emptyLineCount = match.length - 1;
                        return '\n' + '\n&nbsp;'.repeat(emptyLineCount) + '\n';
                    });
                }
                const result = await unified()
                    .use(remarkParse)
                    .use(remarkGfm)
                    .use(breaks)
                    .use(remarkRehype)
                    .use(rehypeStringify)
                    .process(decodedMarkdown);
                setHtml(String(result));
            }
            catch (err) {
                setError(err);
            }
        };
        convertMarkdownToHtml();
    }, [markdownText, version]);
    return { html, error };
};
